import { updatesItems } from '@/mocks/homeMangaData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">更新快讯</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            最新漫画入库动态、活动公告与平台资讯，第一时间掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesItems.map((item) => (
            <div
              key={item.id}
              className="relative flex gap-4 md:gap-5 pb-6 last:pb-0 group cursor-pointer"
            >
              <div className="flex-shrink-0 flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 ring-4 ring-primary-100"></div>
                <div className="w-px flex-1 bg-background-200 mt-2 group-last:hidden"></div>
              </div>

              <div className="flex-1 pb-2">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${item.typeColor}`}>
                    {item.type}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#updates"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-lg text-sm font-medium text-foreground-600 transition-colors cursor-pointer"
          >
            查看更多更新 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}